export interface Topic {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  count: number;
}

export const topics: Topic[] = [
  {
    slug: "ranking-watch",
    name: "打榜观察",
    desc: "盯紧投票通道的每一个异常时段，记录那些需要被解释的票数跳涨。",
    icon: "ri-radar-line",
    count: 12,
  },
  {
    slug: "vote-analysis",
    name: "票数分析",
    desc: "把榜单拆成数据来看，成本、增速、结构，一票一票地算清楚。",
    icon: "ri-bar-chart-2-line",
    count: 15,
  },
  {
    slug: "fan-ecosystem",
    name: "粉丝生态",
    desc: "后援会、集资、内战与和解，围观打榜背后的组织与情绪。",
    icon: "ri-group-line",
    count: 18,
  },
  {
    slug: "contest-rules",
    name: "赛事规则",
    desc: "评委加权、人气占比、计票方式，读懂规则才能读懂名次。",
    icon: "ri-file-list-3-line",
    count: 9,
  },
  {
    slug: "backstage",
    name: "幕后故事",
    desc: "聚光灯之外的人与事，那些不会被写进榜单的真实处境。",
    icon: "ri-movie-2-line",
    count: 11,
  },
];

export const topicNames: string[] = [
  "全部",
  "打榜观察",
  "票数分析",
  "粉丝生态",
  "赛事规则",
  "幕后故事",
];